import type { ReactNode } from 'react';
import './AuthCard.css';

interface AuthCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}

/** Conteneur commun aux ecrans de connexion, d'inscription et de mot de passe. */
export function AuthCard({ title, subtitle, children, footer }: AuthCardProps) {
  return (
    <div className="fg-auth">
      <section className="fg-auth__card">
        <h1 className="fg-auth__title">{title}</h1>
        {subtitle && <p className="fg-auth__subtitle">{subtitle}</p>}
        {children}
      </section>
      {footer && <div className="fg-auth__footer">{footer}</div>}
    </div>
  );
}
